






import Vue from 'vue'

export default Vue.extend({
  name: 'EmailInfo',
  data() {
    return {}
  },
  methods: {
    // would like to change this to emit to parent
    sendEmail() {
      window.location.href = 'mailto:elleryba@icloud.com'
    },
  },
})
